/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import formFieldsConfig from "../config/registerForm.config.json";
import loadingConfig from "../config/loading.config.json";
import errorConfig from "../config/error.config.json";

export interface IStaticPageContentMethods extends IPluginMethodMap {
  getStaticPageContentSync(args: any): any;
}

export class StaticPageContentService implements IAgentPlugin {
  readonly methods: IStaticPageContentMethods;

  constructor() {
    this.methods = {
      getStaticPageContentSync: this.getProps.bind(this),
    };
  }

  getProps(args: any) {
    return {
      fields: formFieldsConfig?.fields,
      layout: formFieldsConfig?.layout,
      title: formFieldsConfig?.title,
      logo: formFieldsConfig?.logo,
      loading: loadingConfig,
      error:errorConfig,
    };
  }
}
